
import { LoaderCircle } from 'lucide-react';
export function Spinner() {
  return (
    <LoaderCircle color="white" className="animate-spin"></LoaderCircle>
  );
}